import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';

@Pipe({
  name: 'referer',
  standalone: true,
})
export class RefererPipe implements PipeTransform {
  constructor(private readonly router: Router) {}

  transform(param: string, ...args: any[]): { referer: string } {
    return { referer: this.router.url };
  }
}
